/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const REGISTER_SAGA = "app/REGISTER_SAGA";

export const LOGIN = "app/LOGIN";
export const LOGIN_SUCCESS = "app/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "app/LOGIN_FAILURE";

export const CHECK = "app/CHECK";
export const CHECK_SUCCESS = "app/CHECK_SUCCESS";
export const CHECK_FAILURE = "app/CHECK_FAILURE";

export const LOGOUT = "app/LOGOUT";
export const LOGOUT_SUCCESS = "app/LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "app/LOGOUT_FAILURE";

export const GOOGLE_INITIALIZED = "app/GOOGLE_INITIALIZED";

export const SENT_RESET_PASSWORD = "app/SENT_RESET_PASSWORD";
export const SENT_RESET_PASSWORD_SUCCESS = "app/SENT_RESET_PASSWORD_SUCCESS";
export const SENT_RESET_PASSWORD_FAILURE = "app/SENT_RESET_PASSWORD_FAILURE";
export const SENT_RESET_PASSWORD_PENDING = "app/SENT_RESET_PASSWORD_PENDING";

// ONE TIME VERIFICATION
export const ACCOUNT_ACTIVATE = "app/ACCOUNT_ACTIVATE";
export const ACCOUNT_ACTIVATE_SUCCESS = "app/ACCOUNT_ACTIVATE_SUCCESS";
export const ACCOUNT_ACTIVATE_FAILURE = "app/ACCOUNT_ACTIVATE_FAILURE";

// ONE TIME VERIFICATION PASSWORD
export const UPDATE_PASSWORD = "app/UPDATE_PASSWORD";
export const UDPATE_PASSWORD_SUCCESS = "app/UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "app/UPDATE_PASSWORD_FAILURE";
export const RESET_UPDATE_PASSWORD = "app/RESET_UPDATE_PASSWORD";

// ACTIVATE/SUSPEND CONTACTOR/ENGINEER
export const ACTIVATE_USER = "app/ACTIVATE_USER";
export const ACTIVATE_USER_SUCCESS = "app/ACTIVATE_USER_SUCCESS";
export const ACTIVATE_USER_FAILURE = "app/ACTIVATE_USER_FAILURE";

export const VERIFY_OTP = "app/VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "app/VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "app/VERIFY_OTP_FAILURE";

export const DOWNLOAD_FILE = "app/DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "app/DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "app/DOWNLOAD_FILE_FAILURE";

export const REGISTER_ACCOUNT = "app/REGISTER_ACCOUNT";
export const REGISTER_ACCOUNT_SUCCESS = "app/REGISTER_ACTIVATE_SUCCESS";
export const REGISTER_ACCOUNT_FAILURE = "app/REGISTER_ACTIVATE_FAILURE";

export const FORGOT_PASSWORD = "app/FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "app/FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "app/FORGOT_PASSWORD_FAILURE";

export const RESET_PASSWORD = "app/RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "app/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "app/RESET_PASSWORD_FAILURE";

// TWO FACTOR AUTHENTICATION
export const VERIFY_2FA = "app/VERIFY_2FA";
export const VERIFY_2FA_SUCCESS = "app/VERIFY_2FA_SUCCESS";
export const VERIFY_2FA_FAILURE = "app/VERIFY_2FA_FAILURE";

export const RESEND_2FA = "app/RESEND_2FA";
export const RESEND_2FA_SUCCESS = "app/RESEND_2FA_SUCCESS";
export const RESEND_2FA_FAILURE = "app/RESEND_2FA_FAILURE";

export const SHOW_2FA_SCREEN = "app/SHOW_2FA_SCREEN";
export const HIDE_2FA_SCREEN = "app/HIDE_2FA_SCREEN";
